import { ChevronDown } from "lucide-react";
import { TableCell, TableRow } from "@/components/ui/table";
import { fmtHrs } from "@/lib/timesheet";

export const STATUS = {
  submitted: ["Invoice submitted", "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-950/40 dark:text-blue-300"],
  ready: ["Ready to submit", "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300"],
  in_progress: ["In progress", "border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-300"],
};

export const money = (n) => (n === null || n === undefined ? "-" : `£${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

const Num = ({ v, bold, testId }) => <TableCell data-testid={testId} className={`text-right font-mono tabular ${bold ? "font-bold" : ""}`}>{fmtHrs(v)}</TableCell>;

const Breakdown = ({ r }) => (
  <TableRow data-testid={`hours-breakdown-${r.user_id}`} className="bg-secondary/20 hover:bg-secondary/20">
    <TableCell colSpan={9} className="px-10 py-3">
      {r.breakdown.length === 0 ? <p className="text-sm text-muted-foreground">No hours recorded this month.</p> : (
        <table className="w-full max-w-3xl text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground">
            <th className="py-1 font-semibold">Client</th><th className="py-1 font-semibold">Project</th>
            <th className="py-1 text-right font-semibold">Standard</th><th className="py-1 text-right font-semibold">Overtime</th>
            <th className="py-1 text-right font-semibold">Leave</th><th className="py-1 text-right font-semibold">Total</th>
          </tr></thead>
          <tbody>{r.breakdown.map((b) => (
            <tr key={`${b.client}|${b.project}`} className="border-t border-border/60">
              <td className="py-1.5 font-medium">{b.client}</td><td className="py-1.5 text-muted-foreground">{b.project || "-"}</td>
              <td className="py-1.5 text-right font-mono tabular">{fmtHrs(b.standard)}</td><td className="py-1.5 text-right font-mono tabular">{fmtHrs(b.overtime)}</td>
              <td className="py-1.5 text-right font-mono tabular">{fmtHrs(b.leave)}</td><td className="py-1.5 text-right font-mono font-semibold tabular">{fmtHrs(b.total)}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </TableCell>
  </TableRow>
);

export const HoursRow = ({ r, open, onToggle }) => {
  const [label, cls] = STATUS[r.status];
  return (
    <>
      <TableRow data-testid={`hours-row-${r.user_id}`} className="cursor-pointer" onClick={onToggle} aria-expanded={open}>
        <TableCell>
          <div className="flex items-center gap-2 font-medium">
            <ChevronDown className={`h-4 w-4 shrink-0 text-muted-foreground transition-transform ${open ? "" : "-rotate-90"}`} />
            <span>{r.name}<span className="block text-xs font-normal text-muted-foreground">{r.weeks_approved}/{r.weeks_total} weeks approved</span></span>
          </div>
        </TableCell>
        <Num v={r.standard} /><Num v={r.overtime} /><Num v={r.leave} />
        <Num v={r.worked} bold testId={`hours-worked-${r.user_id}`} />
        <TableCell className="text-right font-mono tabular text-muted-foreground">{money(r.hourly_rate)}</TableCell>
        <TableCell data-testid={`hours-amount-${r.user_id}`} className="text-right font-mono font-bold tabular">{money(r.amount)}</TableCell>
        <TableCell className="font-mono text-sm">{r.invoice_number || "-"}</TableCell>
        <TableCell><span className={`whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>{label}</span></TableCell>
      </TableRow>
      {open && <Breakdown r={r} />}
    </>
  );
};
